import * as _ from 'underscore';
import { EditorModel } from '.';

class EditorPageThumb {
   page:EditorPageModel;
   html:string;
   scale:string;
   width:number;
   height:number;
}

export interface EditorPageModel {
   readonly sortable?:boolean;
}

export abstract class EditorPageModel {
   constructor(protected editor:EditorModel) { }

   thumbs:EditorPageThumb[];

   layerIndex = 0;

   abstract view:string;
   abstract settings:any;

   /**
    * Read-only settings object which combines the page settings with the
    * experience settings.
    */
   get viewSettings() {
      return _.extend({}, this.editor.settings, _.omit(this.settings, _.isNull));
   }
}
